import React, { useState, useRef, useEffect } from 'react';
import { withNamespaces } from 'react-i18next';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import i18next from 'i18next';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import styles from '@styles/punch.module.css';
import { FloatingActionButton } from "@progress/kendo-react-buttons";
import { plusIcon, fileReportIcon, eyeIcon } from "@progress/kendo-svg-icons";
import { isIOS } from '@utils';
import ReportDailyForm from '@components/punch/report/ReportDailyForm';
import ReportEventForm from '@components/punch/report/ReportEventForm';
import AlertAlgo from '@controls/AlertSnack';
import Popup from '@controls/Popup';
import { getListReport } from '@actions/reportDaily/index';
import { getListEventReport } from '@actions/reportEvent/index';
import * as StatusCode from '@scripts/StatusCode';
import * as storage from '@utils/storage'
import IconButton from '@material-ui/core/IconButton';
import { SvgIcon } from '@progress/kendo-react-common';
import ReportViewer from '@shared/reportViewer/ReportViewer';
import { reportTypes } from '@utils/reportHelper';

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
}));

function PunchReportList(props) {
    const classes = useStyles();

    const { punchId, isEnabled } = props;

    const alertRef = useRef(null);
    const [reportId, setReportId] = useState(0);
    const [openPopDaily, setOpenPopDaily] = useState(false);
    const [openPopEvent, setOpenPopEvent] = useState(false);
    const [isiOS, setIsiOS] = React.useState(isIOS());
    const [useDailyReport, setUseDailyReport] = React.useState(storage.getUseDailyReport());
    const [useEventReport, setUseEventReport] = React.useState(storage.getUseEventReport());
    const [listDailyReport, setListDailyReport] = React.useState(null);
    const [listEventReport, setListEventReport] = React.useState(null);
    const [openReport, setOpenReport] = useState(false);
    const [reportType, setReportType] = useState(reportTypes.FlAG);
    const [reportParameters, setReportParameters] = useState(null);

    useEffect(() => {
        loadList();
    }, []);

    useEffect(() => {
        console.log(listEventReport, 'listEventReport');
    }, [listEventReport]);

    const loadList = async () => {
        // Load daily report list
        var result = await getListReport(punchId);

        if (result.status === StatusCode.STATUS_OK) {
            setListDailyReport(result.result);
        } else {
            showMessageError(i18next.t('error:generic-error'));
        }

        // Load event report list
        var resultEvent = await getListEventReport(punchId);

        if (resultEvent.status === StatusCode.STATUS_OK) {
            setListEventReport(resultEvent.result);
        } else {
            showMessageError(i18next.t('error:generic-error'));
        }
    }

    const handleClosePopDaily = (showSuccess) => {
        setOpenPopDaily(false);
        loadList();

        if (showSuccess) {
            showMessageSuccess(i18next.t('common:successMessage'));
        }
    }

    const handleClosePopEvent = (showSuccess) => {
        setOpenPopEvent(false);
        loadList();

        if (showSuccess) {
            showMessageSuccess(i18next.t('common:successMessage'));
        }
    }

    const handleEditReportDaily = (reportId) => {
        setReportId(reportId);
        setOpenPopDaily(true);
    }

    const handleEditReportEvent = (reportId) => {
        setReportId(reportId);
        setOpenPopEvent(true);
    }

    const showMessageSuccess = (message) => {
        alertRef.current.showMessageSuccess(message);
    }

    const showMessageError = (message) => {
        alertRef.current.showMessageError(message);
    }

    const StyledTableCell = withStyles((theme) => ({
        head: {
            backgroundColor: "var(--color1)",
            color: theme.palette.common.white,
            padding: "5px"
        },
        body: {
            fontSize: 14,
        }
    }))(TableCell);

    const StyledFirstTableCell = withStyles((theme) => ({
        body: {
            fontSize: 14,
            width: '500px !important',
            fontWeight: "bold",
            textAlignLast: 'left !important'
        },
    }))(TableCell);

    const StyledActionTableCell = withStyles(() => ({
        body: {
            width: '48px',
            padding: '0 8px',
            textAlign: 'right',
            whiteSpace: 'nowrap'
        },
    }))(TableCell);

    const handleClick = (eventType) => {
        handleAddReport(eventType.itemIndex);
    };

    const handleAddReport = (index) => {
        if (index === 0) {
            // Daily report
            setReportId(0);
            setOpenPopDaily(true);
        } else if (index === 1) {
            // Event report
            setReportId(0);
            setOpenPopEvent(true);
        }
    }

    const getItems = () => {
        var items = [];

        if (useDailyReport) {
            items.push(
                {
                    svgIcon: fileReportIcon,
                    text: i18next.t('punch:report.button.daily-report'),
                    disabled: !useDailyReport
                });
        }

        if (useEventReport) {
            items.push(
                {
                    svgIcon: fileReportIcon,
                    text: i18next.t('punch:report.button.event-report'),
                    disabled: !useEventReport
                }
            )
        }

        return items;
    }

    const handleViewReport = (e, reportId, isEvent) => {
        e.stopPropagation(); // prevents the row's edit popup from opening

        setReportType(isEvent ? reportTypes.EVENT_REPORT : reportTypes.DAILY_REPORT);
        setReportParameters({ EntryId: reportId });
        setOpenReport(true);
    };

    const handleCloseReport = () => {
        setOpenReport(false);
    }

    return (
        <>
            <div id="divListReport" className={styles.detailPunch}>
                {useDailyReport && (<TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="spanning table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell align="center" colSpan={2} className={classes.head}>
                                    {i18next.t('punch:report.daily.daily-report')}
                                </StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {listDailyReport && listDailyReport.map((item, index) => (
                                <TableRow key={index} onClick={() => handleEditReportDaily(item.reportId)}>
                                    <StyledFirstTableCell>{item.title}</StyledFirstTableCell>
                                    <StyledActionTableCell>
                                        <IconButton
                                            size="small"
                                            aria-label={i18next.t('common:view')}
                                            title={i18next.t('common:view')}
                                            onClick={(e) => handleViewReport(e, item.reportIdCrypt, false)}
                                        >
                                            <SvgIcon icon={eyeIcon} />
                                        </IconButton>
                                    </StyledActionTableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>)}
                {useEventReport && (<TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="spanning table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell align="center" colSpan={2} className={classes.head}>
                                    {i18next.t('punch:report.daily.event-report')}
                                </StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {listEventReport && listEventReport.map((item, index) => (
                                <TableRow key={index} onClick={() => handleEditReportEvent(item.reportId)}>
                                    <StyledFirstTableCell>{item.title}</StyledFirstTableCell>
                                    <StyledActionTableCell>
                                        <IconButton
                                            size="small"
                                            aria-label={i18next.t('common:view')}
                                            title={i18next.t('common:view')}
                                            onClick={(e) => handleViewReport(e, item.reportIdCrypt, true)}
                                        >
                                            <SvgIcon icon={eyeIcon} />
                                        </IconButton>
                                    </StyledActionTableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>)}
            </div>

            {isEnabled && <div style={{ position: "relative", display: "inline-block" }}>
                <FloatingActionButton
                    className={`addButtonFab floatingActionButton ${isiOS && "addButtonFabIOS"}`}
                    svgIcon={plusIcon}
                    items={getItems()}
                    onItemClick={handleClick}
                    position="absolute"
                    align={{ horizontal: "end", vertical: "bottom" }}
                />
            </div>}

            <Popup title={i18next.t('dailyReport:title')} openPop={openPopDaily} handleClosePop={() => handleClosePopDaily(false)}>
                <ReportDailyForm punchId={punchId} reportDailyId={reportId} onClose={handleClosePopDaily} isEnabled={isEnabled} />
            </Popup>

            <Popup title={i18next.t('eventReport:title')} openPop={openPopEvent} handleClosePop={() => handleClosePopEvent(false)}>
                <ReportEventForm punchId={punchId} reportEventId={reportId} onClose={handleClosePopEvent} isEnabled={isEnabled} />
            </Popup>

            <ReportViewer
                open={openReport}
                reportType={reportType}
                reportParameters={reportParameters}
                onClose={handleCloseReport}
                zIndex={10001}
            />

            <AlertAlgo ref={alertRef} />
        </>
    )
}

export default withNamespaces(['dailyReport', 'eventReport', 'common', 'punch', 'error', 'report'], { wait: true })(PunchReportList);